import { z } from 'zod';

import { TeamLeaguePlayerStatus } from '@/entities/TeamPlayerInfo';

export const captainManagerDesignationSchema = z.object({
	role: z.nativeEnum(TeamLeaguePlayerStatus),
	lineupStrength: z.number().min(0).max(10).optional().nullable()
});
export type CaptainManagerDesignationData = z.infer<typeof captainManagerDesignationSchema>;
